import React, { ReactElement, useContext } from "react";
import "./AboutUs.css";
import { useNavigate } from "react-router-dom";
import GeneralLayoutWithDots from "./components/GeneralLayoutWithDots";
import AuthContext from "../../store/AuthContext";

export default function Join(): ReactElement {
  const navigate = useNavigate();
  const { loggedPerson } = useContext(AuthContext);

  const handleMembershipDuesNavigation = () => {
    if (loggedPerson) {
      navigate("/membership-dues");
    } else {
      navigate("/login");
      // Scroll to top when navigating to login
      setTimeout(() => {
        window.scrollTo(0, 0);
        const contentDiv = document.getElementById("content-container");
        if (contentDiv) {
          contentDiv.scrollTop = 0;
        }
      }, 100);
    }
  };
  return (
      <div className="bg-[#FFFFFF] w-full">
        <GeneralLayoutWithDots
          subTitle="More About WSG"
          CurrentPage="Join"
        >
          <>
            {/* Join WSG Content Section */}
            <div className="about-us-page-content py-8">
              {/* Main Content - Full Width */}
              <div className="w-full">
                {/* Main Content */}
                <div className="w-full">
                  {/* Introduction Section */}
                  <div className="mb-14">
                    <p className="join-paragraph mb-6 text-left">
                      World Services Group is the most prominent global network
                      of independent firms that provides an exclusive setting
                      and platform to connect its members to the most elite
                      legal firms and their multinational clients worldwide.
                      Additionally, WSG provides cross industry access to a
                      select few investment banking and accounting firms
                      creating more expansive opportunities to service clients.
                      For further information about becoming a member, please
                      contact WSG at,{" "}
                      <a
                        href="mailto:info@worldservicesgroup.com"
                        className="text-blue-600 hover:text-red-600 hover:underline transition-colors"
                      >
                        info@worldservicesgroup.com
                      </a>
                    </p>
                  </div>

                  {/* WSG Membership Section */}
                  <div className="mb-14">
                    <h2 className="join-title mb-6 text-left">
                      WSG Membership
                    </h2>
                    <p className="join-paragraph mb-6 text-left">
                      World Services Group is comprised of over 120 prominent
                      firms representing multinational clients worldwide.
                      Members act in over 150 jurisdictions with over 23,000
                      professionals globally.
                    </p>
                    <p className="join-paragraph mb-6 text-left">
                      WSG members have an established record of standing and
                      client success. Only firms of the highest quality
                      principles, recognized expertise and excellent client
                      service are given the opportunity to be considered. Firm
                      membership is subject to review across multiple leadership
                      channels and is selected based on strict objective
                      standards established by the Board of Directors including:
                    </p>
                    <ul className="space-y-4 mb-8 pl-[20px]">
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-gray-600 rounded-full mt-3 mr-4 flex-shrink-0"></div>
                        <p className="join-paragraph">
                          Having unparalleled depth of practical experience,
                          knowledge and expertise with proven success
                        </p>
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-gray-600 rounded-full mt-3 mr-4 flex-shrink-0"></div>
                        <p className="join-paragraph">
                          Having the highest professional reputation within the
                          industry
                        </p>
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-gray-600 rounded-full mt-3 mr-4 flex-shrink-0"></div>
                        <p className="join-paragraph">
                          Being considered among leading national, regional
                          and/or international firms
                        </p>
                      </li>
                    </ul>
                    <p className="join-paragraph mb-8 text-left">
                      WSG is a non-exclusive organization and members may belong
                      to other associations, networks or alliances.
                    </p>
                  </div>

                  {/* Join WSG Section */}
                  <div className="mb-14">
                    <h2 className="join-title mb-6 text-left">Join WSG</h2>
                    <p className="join-paragraph mb-6 text-left">
                      WSG is a non-exclusive organization. Members may belong to
                      other associations, networks, or alliances. While
                      membership to WSG is primarily by invitation, a firm may
                      approach WSG directly. Members are typically nominated by
                      a current member and are selected based upon strict
                      objective standards. Each nomination must be agreed to by
                      all members of the jurisdiction and the Board of
                      Directors. If all membership criteria are met, a firm may
                      be invited to apply.
                    </p>

                    <p className="join-paragraph mb-6 text-left font-semibold">
                      Membership Process:
                    </p>

                    <ol className="space-y-4 mb-8 list-decimal list-inside text-left">
                      <li className="join-paragraph">
                        Nomination: Firm nominated by WSG member and interviewed
                      </li>
                      <li className="join-paragraph">
                        Regional Review: Firm evaluated by regional members
                      </li>
                      <li className="join-paragraph">
                        Application: Firm submits application and application
                        fees
                      </li>
                      <li className="join-paragraph">
                        Board Review: Board evaluation and discussion
                      </li>
                      <li className="join-paragraph">
                        Board Vote: Formal vote of the Board of Directors
                      </li>
                      <li className="join-paragraph">
                        Approval: Applicant informed of Board decision
                      </li>
                    </ol>
                  </div>

                  {/* Value of Membership */}
                  <div className="mb-14">
                    <h2 className="join-title mb-6 text-left">
                      Value of Membership
                    </h2>
                    <p className="join-paragraph mb-6 text-left">
                      Built upon a platform of innovation and technology, WSG
                      provides better packaged services that include membership
                      for all firm professionals, providing more value compared
                      to the traditional competitor.{" "}
                      <button
                        onClick={handleMembershipDuesNavigation}
                        className="text-blue-600 hover:text-red-600 hover:underline transition-colors cursor-pointer bg-transparent border-none p-0 font-inherit"
                      >
                        Member dues
                      </button>{" "}
                      are set by the Board of Directors and are classified by service industry
                      and jurisdiction representation.
                    </p>
                  </div>

                  {/* Member Protocols */}
                  <div className="mb-0">
                    <h2 className="join-title mb-6 text-left">
                      Member Protocols
                    </h2>
                    <p className="join-paragraph mb-6 text-left">
                      WSG is the world leading association of independent
                      professional services firms. The Members operate
                      independently and are not responsible for each other’s
                      work or business. However, Members are expected to provide
                      excellent service and adhere to the following WSG
                      Membership Protocols.
                    </p>

                    <div className="space-y-6">
                      <div>
                        <p className="join-paragraph mb-4 text-left">
                          1. Performance/Service Delivery
                        </p>
                        <div className="space-y-3 ml-6 text-left">
                          <p className="join-paragraph">
                            1.1. Each Member shall commit to provide excellent
                            service to member inquiries as provided by their own
                            client service standards in English, and through
                            electronic and/or telephone to ensure prompt
                            response.
                          </p>
                          <p className="join-paragraph">
                            1.2. Member contacts designated as main, primary,
                            secondary or liaison contacts will provide clear and
                            prompt acknowledgement of any member inquiry within
                            24 hours of the initial request together with a
                            timeframe for providing confirmation of requested
                            service.
                          </p>
                          <p className="join-paragraph">
                            1.3. Free Advice Policy: Members shall provide up to
                            30 minutes of free initial general guidance to other
                            members. This policy is not applicable if the Member
                            is conflicted, research is required, documents are
                            to be reviewed or any opinion is provided that the
                            consulting Member uses as a work product.
                          </p>
                          <p className="join-paragraph">
                            1.4. In the event that an initial communication
                            develops into an engagement, the following
                            principles will be adhered to:
                          </p>
                          <p className="join-paragraph ml-6">
                            1.4.1. Members receiving the referral will provide,
                            upon request, an engagement letter which will
                            clarify the scope of services, how the fees will be
                            determined, calculated and billed.
                          </p>
                          <p className="join-paragraph ml-6">
                            1.4.2. Members receiving the referral will provide
                            the details of the principal professionals inclusive
                            of key support staff.
                          </p>
                          <p className="join-paragraph ml-6">
                            1.4.3. Members must consider alternative fee
                            arrangements when requested to do so.
                          </p>
                          <p className="join-paragraph ml-6">
                            1.4.4. Members receiving the referral are obliged to
                            render invoices properly.
                          </p>
                          <p className="join-paragraph ml-6">
                            1.4.5. Members receiving the referral are obliged to
                            provide status or progress reports wherever
                            requested.
                          </p>
                        </div>
                      </div>

                      <div>
                        <p className="join-paragraph mb-4 text-left">
                          2. Technology & Infrastructure
                        </p>
                        <div className="space-y-3 ml-6 text-left">
                          <p className="join-paragraph">
                            2.1. WSG Members are required to have professionals
                            and staff who are fluent in written and spoken
                            English in addition to their local language. They
                            will also have access to resources for linguistic
                            capability in other languages, whenever required
                          </p>
                          <p className="join-paragraph">
                            2.2. Free Office Policy: The "Free Office Policy"
                            makes available offices, conference rooms,
                            telephones, fax machines and secretarial support
                            within reason at other members' offices to all
                            members with a need while traveling on business.
                            Effectively, this policy gives each member access to
                            offices worldwide.
                          </p>
                          <p className="join-paragraph">
                            2.3. Members shall have 24/7 access to internet.
                          </p>
                          <p className="join-paragraph">
                            2.4. WSG members are committed to provide and use
                            the following for effective communication:
                          </p>
                          <p className="join-paragraph ml-6">
                            2.4.1. Each professional should have access to the
                            Internet and have their own e-mail address.
                          </p>
                          <p className="join-paragraph ml-6">
                            2.4.2. The firm must use office software that
                            supports the compatible exchange of files and data
                            as generally used by the industry in which it
                            operates
                          </p>
                          <p className="join-paragraph ml-6">
                            2.4.3. The firm will have anti-virus protection and
                            a system for regular back-ups.
                          </p>
                          <p className="join-paragraph ml-6">
                            2.4.4. Voicemail with English language prompts.
                          </p>
                        </div>
                      </div>

                      <div>
                        <p className="join-paragraph mb-4 text-left">
                          3. Member Commitment to World Services Group
                        </p>
                        <div className="space-y-3 ml-6 text-left">
                          <p className="join-paragraph">
                            3.1. WSG Member firms commit to their WSG membership
                            through the promotion of their membership including
                            the following recommended protocols:
                          </p>
                          <p className="join-paragraph ml-6">
                            3.1.1. Providing current designated WSG contacts
                            within the firm
                          </p>
                          <p className="join-paragraph ml-6">
                            3.1.2. Adding the logo, description and link of WSG
                            to their website
                          </p>
                          <p className="join-paragraph ml-6">
                            3.1.3. Current upkeep of firm information on the WSG
                            website
                          </p>
                          <p className="join-paragraph ml-6">
                            3.1.4. Acknowledgement of WSG membership in firm
                            boilerplate for press releases
                          </p>
                          <p className="join-paragraph ml-6">
                            3.1.5. Input and use of the WSG referral tracker for
                            member collaborations
                          </p>
                          <p className="join-paragraph ml-6">
                            3.1.6. Participation in designated WSG discussion
                            groups for members
                          </p>
                          <p className="join-paragraph">
                            3.2. Members' active contacts endeavor to keeping
                            the Member firm internally informed of developments
                            within WSG and opportunities to contribute to active
                            participation and leadership among WSG and its
                            members.
                          </p>
                          <p className="join-paragraph">
                            3.3. Each Member of WSG shall endeavor to ensure
                            attendance to at least one regional, annual or
                            practice group meeting annually.
                          </p>
                          <p className="join-paragraph">
                            3.4. WSG members will be evaluated for their service
                            performance and adherence to these policies
                            periodically, and this will impact their continuing
                            membership in WSG.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </GeneralLayoutWithDots>
      </div>
  );
}
